import { render, staticRenderFns } from "./DialogFirmas.vue?vue&type=template&id=e2299c4a&scoped=true"
import script from "./DialogFirmas.vue?vue&type=script&lang=js"
export * from "./DialogFirmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2299c4a",
  null
  
)

export default component.exports